import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AddUsers from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.addUsersChat,
    connections: state.userConnections.connections,
  };
}
function mapDispatchToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddUsers));



// WEBPACK FOOTER //
// ./src/components/AddUsers/container/index.js